/* @ngInject */
function CardTagsController ($scope, $timeout, $attrs) {
  $scope.allTags = {
    toShow: [],
    toHide: []
  }

  const api = {
    _defineTagsToShow
  }
  this.getApi = () => api

  function activate () {
    if ($scope.tags?.length) {
      $timeout(() => {
        api._defineTagsToShow()
        $timeout(() => {
          $($attrs.$$element.find('.tags-list-tooltip')[0]).popup({
            delay: {
              show: 1000,
              hide: 0
            }
          })
        }, 350, false)
      }, 250)
    }
  }

  const deregisterTagsWatcher = $scope.$watch('tags', (newValue) => {
    $timeout(() => {
      $scope.allTags.toShow = []
      $scope.allTags.toHide = []

      activate()
    }, 100)
  })

  $scope.getTagsTooltip = (tags) => {
    let text = ''

    tags.forEach(tag => {
      text += `${tag.label}<br>`
    })

    return text
  }

  function _defineTagsToShow () {
    const listWidth = $($attrs.$$element.find('.tags-list')[0]).width()
    let occupiedWidth = 0
    const pillPadding = 16
    const characterAvgWidth = 8

    let index = 0

    while (listWidth >= occupiedWidth && $scope.tags.length - 1 >= index) {
      const tag = $scope.tags[index]
      const tagCharacterWidth = tag.label.length * characterAvgWidth
      occupiedWidth += tagCharacterWidth + pillPadding

      if (listWidth >= occupiedWidth) {
        $scope.allTags.toShow.push(tag)
      } else {
        $scope.allTags.toHide.push(tag)
      }

      index++
    }

    if ($scope.tags.length - 1 >= index) {
      const hiddenTags = $scope.tags.slice(index, $scope.tags.length)
      $scope.allTags.toHide.push(...hiddenTags)
    }
  }

  $scope.$on('$destroy', () => {
    deregisterTagsWatcher()
  })
}

export { CardTagsController }
